module.exports = __webpack_public_path__ + "static/media/star.71772d0a.svg";